"use strict";
// ================================================================
// v2/index.ts
// v2 デザインシステム (EventDetail UT-27465 起点) のエントリポイント。
//
// utoniq-app からは namespace 経由で利用する:
//   import { v2 } from 'utoniq-ui'
//   <v2.PreSaleCard ... />
//   v2.createV2Palette('light')
//   v2.radius.md / v2.textStyles.sectionTitle
// ================================================================
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./components"), exports);
__exportStar(require("./theme"), exports);
__exportStar(require("./tokens"), exports);
